<template>
  <div class="evaluation-sections-navigator">
    <ul>
      <li
        v-for="(section, $index) of items"
        :key="section.id"
        :class="{selected: section.$selected, active: currentSectionIndex >= $index }"
        class="section"
      >
        <a
          href=""
          @click.prevent="selectSection($index)"
        >{{ section.name }}
        </a>
        <ul>
          <li
            v-for="subsection of filteredSubsections(section.$children)"
            :key="subsection.id"
            class="subsection"
          >
            <a
              href=""
              @click.prevent="selectSection($index)"
            >
              {{ subsection.name }}
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

////////////////////////////
//                   SCRIPT
////////////////////////////
<script>
export default {
  name: 'EvaluationSectionsNavigator',
  props: {
    items: {
      type: Array,
      required: true,
      default () {
        return []
      }
    },
    currentSectionIndex: {
      type: null,
      required: true
    }
  },
  data () {
    return {}
  },
  methods: {
    /**
     * Selects a section
     */
    selectSection (sectionIndex) {
      this.$emit('sectionSelected', sectionIndex)
      this.currentSectionIndex = sectionIndex
    },
    /**
     * Returns only the subsections in the
     * section items
     * @param children
     * @returns {*}
     */
    filteredSubsections (children) {
      return children.filter(element => {
        return element.$group === 'subsection'
      })
    }
  }
}
</script>

////////////////////////////
//                    STYLE
////////////////////////////
<style
  lang="scss"
  scoped
>
.evaluation-sections-navigator {
  padding-top: 20px;
  padding-left: 40px;
  ul {
    display: block;
    margin: 0;
    padding: 0;
  }
  .section {
    border-left: 1px solid #cccccc;
    list-style: none;
    display: block;
    padding: 0 30px 10px;
    padding-bottom: 40px;
    position: relative;
    a {
      display: block;
      text-decoration: none;
      color: #444;
      @include font-primary(14px, bold);
    }
    .subsection {
      list-style: none;
      display: block;
      padding: 10px;
      a {
        display: block;
        text-decoration: none;
        color: #444;
        @include font-primary(12px, regular);
      }
    }
    &:before {
      content: "";
      height: 10px;
      width: 10px;
      background-color: #cccccc;
      position: absolute;
      left: -5px;
      border-radius: 100%;
      transition: all 0.3s ease-in-out;
    }
    &:nth-child(1) {
      padding-top: 0;
    }
    &:nth-last-child(1) {
      border: none;
      padding-top: 0;
    }
  }
  .active {
    border-left: 1px solid #444444;
    &:before {
      content: "";
      height: 10px;
      width: 10px;
      background-color: #444444;
      position: absolute;
      left: -5px;
      border-radius: 100%;
      transition: all 0.3s ease-in-out;
    }
  }
  .selected {
    border-left: 1px solid #cccccc;
    a {
      color: #444444;
    }
    &:before {
      content: "";
      height: 40px;
      width: 5px;
      background-color: $color-ui-primary;
      position: absolute;
      left: -3px;
      border-radius: 4px;
      transition: all 0.3s ease-in-out;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/evaluation/components/layout/evaluation-sections-navigator.vue